import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import ActionIcon from '../../../../Components/ActionIcon';
import Level3Title from '../../../../app/common/components/title/Level3Title';
import {MAX_VPN_ACCOUNTS, VpnAccount} from '../../Types/routerForms';

interface VpnAccountsSectionProps {
  accounts: VpnAccount[];
  onEdit: (account: VpnAccount) => void;
  onDelete: (id: string) => void;
}

const VpnAccountsSection = ({accounts, onEdit, onDelete}: VpnAccountsSectionProps): JSX.Element => {
  const intl = useIntl();

  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title>
          <Level3Title
            title={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ACCOUNTS_TITLE'})}
          />
        </Card.Title>
        <span className="text-muted fs-6">
          {accounts.length} / {MAX_VPN_ACCOUNTS}
        </span>
      </Card.Header>
      <Card.Body>
        <table className="table table-row-dashed align-middle">
          <thead>
            <tr className="fw-semibold text-muted">
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.LOGIN'})}</th>
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.PASSWORD'})}</th>
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.LOCAL_IP'})}</th>
              <th style={{width: 60}}></th>
            </tr>
          </thead>
          <tbody>
            {accounts.length === 0 && (
              <tr>
                <td colSpan={4} className="text-muted text-center">
                  {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.EMPTY'})}
                </td>
              </tr>
            )}
            {accounts.map((a) => (
              <tr key={a.id}>
                <td>{a.login}</td>
                <td>
                  <span className="me-3">••••••••</span>
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0"
                    onClick={() => onEdit(a)}
                  >
                    {intl.formatMessage({id: 'COMMON.EDIT'})}
                  </button>
                </td>
                <td>
                  {a.remoteAddress ?? (
                    <span className="text-muted">
                      {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.DYNAMIC'})}
                    </span>
                  )}
                </td>
                <td>
                  <ActionIcon
                    label={intl.formatMessage({id: 'COMMON.DELETE'})}
                    faIcon="fa-solid fa-trash text-danger"
                    onClick={() => onDelete(a.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
};

export default VpnAccountsSection;
